import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $patchStyleText } from '@lexical/selection';
import { $getSelection, $isRangeSelection } from "lexical";
import styles from "../ToolbarDropdown.module.scss";

interface IFontFamilyButton {
    fontFamily: string;
    text: string;
    onSelect: () => void;
}

const FontFamilyButton = (
    {
        fontFamily,
        text,
        onSelect,
    }: IFontFamilyButton) => {
    const [editor] = useLexicalComposerContext();

    const setSelected = (e: any) => {
        e.preventDefault();
        e.stopPropagation();

        editor.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                $patchStyleText(selection, {
                    'font-family': fontFamily,
                });
            }
        });
        onSelect();
    }

    return <button
        className={styles.toolbarDropdownItem}
        onClick={setSelected}
        aria-label={text}
    >
        <span className={"ps-2"}>{text}</span>
    </button>
};

export default FontFamilyButton;